$mol_icon_swap_vertical $mol_icon path \M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z
